export default "/images/amazon_music.png?c9e2c0286b5880d606150f56500e841a";